<template>
  <v-cards-container>
    <v-card-icon
      v-for="feature in whyus.features"
      :key="feature.id"
      :icon="feature.icon"
      :cardTitle="feature.title"
    ></v-card-icon>
  </v-cards-container>
</template>

<script>
import VCardsContainer from '@/components/atomic/VCardsContainer.vue';
import VCardIcon from '@/components/atomic/VCardIcon.vue';

export default {
  name: 'HomeCardsIcon',
  components: {
    VCardsContainer,
    VCardIcon,
  },
  data() {
    return {
      whyus: {
        features: [
          {
            id: 1,
            icon: 'ico-wifi.svg',
            text: 'Wi-Fi διατίθεται σε όλους τους χώρους και δεν χρεώνεται',
            title: this.$t('pageHome.whyus.benefits.wifi'),
            title2: 'Wi-Fi Internet.',
          },
          {
            id: 2,
            icon: 'ico-hamburger.svg',
            text: 'Κιόσκι με εγκαταστάσεις BBQ για αξέχαστες οικογενιακές και όχι μόνο στιγμές.',
            title: this.$t('pageHome.whyus.benefits.bbq'),
          },
          {
            id: 3,
            icon: 'ico-parking.svg',
            text: 'Xώρος στάθμευσης στο χώρο του ξενοδοχείου, δεν απαιτείται κράτηση.',
            title: this.$t('pageHome.whyus.benefits.parking'),
          },
          {
            id: 4,
            icon: 'ico-seedling.svg',
            text: '',
            title: this.$t('pageHome.whyus.benefits.garden'),
          },
        ],
      },
    };
  },
};
</script>
